/**
 * The one live region on a game screen.
 *
 * Each game grew its own as it was built, and three of the four ended up with
 * more than one — Scramble had three, two of them mounted at the same time,
 * under a comment claiming there was one. Two polite regions updating in the
 * same tick are read in an order nobody controls, so the reply to the last
 * answer can arrive after the next question has already been read out.
 *
 * So: one region per screen, composed in a fixed order, and every visible block
 * left as ordinary silent text. That does mean somebody reading the page
 * linearly meets the question twice — once here and once where it is drawn.
 * That is a much smaller cost than announcements racing each other, and it is
 * the only version of this that stays consistent across four games.
 */
export function Announce({ children }: { children: string }) {
  return (
    <p className="sr-only" role="status" aria-atomic="true">
      {children}
    </p>
  )
}
